import GreenPageSection from 'components/GreenPageSection';
import Subheading from 'components/Subheading';
import WinnersWallOfFame from 'components/WinnersWallOfFame';
import { useEffect, useState } from 'react';
import { getHomePageStats } from 'api/analytics';
import React from 'react';

const WinnersGreenPageSection = () => {
  return (
    <GreenPageSection additionalClassName="winnersGreenPageSection" noPadding>
      <div className="w-full px-4 md:px-6 lg:px-44">
        <Subheading>
          <span className="normal-case text-3xl">
            Thousands of winners every week
          </span>
        </Subheading>
        <p>Will you be next?</p>

        <WinnersWallOfFame />
      </div>

      <style jsx>
        {`
          :global(.subheadingWrapper .subheading) {
            max-width: 350px;
          }

          :global(.subheadingWrapper .subheading strong) {
            font-size: 2.5em;
            line-height: 1.2em;
          }

          p {
            font-weight: 700;
            font-size: 1.2em;
            margin-top: 1em;
          }

          @media (min-width: 500px) {
            p {
              font-size: 1.4em;
            }
          }
        `}
      </style>
    </GreenPageSection>
  );
};

export default WinnersGreenPageSection;
